<template>
  <div class="card-picker--wrapper" :class="{open: openState}">
    <div class="card-picker--header" @click="openState = false">
      <div class="picker--title">
        {{extra.text.name}}
      </div>
      <div class="picker-icon">
        <i class="las la-angle-double-down"></i>
      </div>
    </div>
    <div class="card-picker" v-if="type === 'NONE' || type === 'EACH'">
      <div class="item-picker--list">
        <div class="item-picker--item" v-for="(date, index) in dates" :key="date.format('YYYYMMDD')" :index="index">
          <div class="item-picker--label">{{date.format('ddd DD')}}</div>
          <number-picker
            :min="0"
            :update-val="getValue(date)"
            @input="(e) => handleDatePickerChange(date, e)"
            style="margin: auto"/>
        </div>
      </div>
    </div>
    <div class="card-picker" v-if="type === 'PERSON'">
      <p>{{$t('extras.personInfo')}}</p>
      <span style="display: flex">
        <number-picker
          :min="0"
          :max="nbGuest"
          :update-val="getValue(startDate)"
          @input="handlePickerChange"
          style="margin: auto"/>
      </span>
    </div>
    <div class="card-picker" v-if="type === 'HOUR'">
      <p>{{$t('extras.hourInfo')}}</p>
      <span style="display: flex">
        <number-picker
          :min="0"
          :update-val="getValue(startDate)"
          @input="handlePickerChange"
          style="margin: auto"/>
      </span>
    </div>
    <div class="card-picker" v-if="type === 'DAY'">
      <div class="date-picker--list">
        <div class="date-picker--item" v-for="(date, index) in dates" :key="date.format('YYYYMMDD')" :index="index"
             @click="toggle(date)">
          <div class="date-picker--label">{{date.format('dddd DD MMM')}}</div>
          <div class="check-box" :class="{selected: isSelected(date)}"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import NumberPicker from "./number-picker";
  import {mapState} from "vuex";

  export default {
    name: "card-extra-picker",
    components: {NumberPicker},
    props: {
      nbDay: {
        type: Number,
        required: true
      },
      extra: {
        type: Object,
        required: true
      },
      nbGuest: {
        type: Number,
        required: false,
        default: 2
      },
      startDate: {
        type: String,
        required: true
      },
      endDate: {
        type: String,
        required: true
      }
    },
    computed: {
      type() {
        return !this.extra ? 'NONE' : this.extra.type;
      },
      dates() {
        let end = moment(this.endDate);
        let tmp = moment(this.startDate);
        if (this.extra.is_next_day) {
          end = end.add(1, 'day');
          tmp = tmp.add(1, 'day');
        }
        const dates = [];
        while (tmp.isBefore(end)) {
          dates.push(tmp.clone());
          tmp = tmp.clone().add(1, 'day');
        }
        return dates;
      },
      storeValue () {
        const storeExtra = this.storedExtras.filter(e => e.extra.id === this.extra.id && !e.is_option);
        if (storeExtra.length === 0) return storeExtra;
        return storeExtra[0].dates.filter(v => v.count > 0);
      },
      ...mapState({
        storedExtras: s => s.shoppingCart.booking.bookingRoom.bookingRoom ? s.shoppingCart.booking.bookingRoom.bookingRoom.extras : [],
      })
    },
    watch: {
      storeValue() {
        this.selectedDates = this.storeValue;
      }
    },
    data() {
      return {
        openState: false,
        selectedDates: []
      }
    },
    mounted () {
      this.selectedDates = this.storeValue;
    },
    methods: {
      triggerChange(v) {
        this.$emit('extra-change', v);
      },
      getValue (date) {
        if (!date) {
          return 0;
        }
        date = moment(date).format('YYYY-MM-DD')
        const input = this.selectedDates.filter(e => e.date === date);
        if (input.length === 0) return 0;
        return input[0].count;
      },
      handleDatePickerChange (date, e) {
        const index = this.selectedDates.map(d => d.date).indexOf(date.format('YYYY-MM-DD'));
        if (index === -1) {
          this.selectedDates.push({
            date: date.format('YYYY-MM-DD'),
            count: e
          });
          this.triggerChange(this.selectedDates.filter(ed => ed.count > 0));
          return;
        }
        this.selectedDates[index].count = e;
        this.triggerChange(this.selectedDates.filter(ed => ed.count > 0));
      },
      handlePickerChange(value) {
        if (value === 0) {
          return this.triggerChange([]);
        }
        this.selectedDates = [
          {
            date: moment(this.startDate).format('YYYY-MM-DD'),
            count: value
          }
        ];
        this.triggerChange(this.selectedDates );
      },
      open() {
        const date = moment(this.startDate);
        const endDate = moment(this.endDate);
        if (this.extra.is_next_day) {
          date.add(1, 'day');
          endDate.add(1, 'day');
        }
        if (this.type === 'ONCE') {
          this.triggerChange([{
            date: date.format('YYYY-MM-DD'),
            count: 1
          }]);
          return;
        }
        if (this.type === 'FIRSTDBOOK') {
          this.triggerChange([{
            date: date.format('YYYY-MM-DD'),
            count: 1
          }]);
          return;
        }
        if (this.type === 'LASTDBOOK') {
          this.triggerChange([{
            date: endDate.format('YYYY-MM-DD'),
            count: 1
          }]);
          return;
        }
        if (this.type === 'DAY' && this.nbDay === 1) {
          this.triggerChange([{
            date: date.format('YYYY-MM-DD'),
            count: 1
          }]);
          return;
        }
        this.openState = true;
      },
      toggle(date) { // TYPE /jour
        if (this.isSelected(date)) {
          this.selectedDates = this.selectedDates.filter(d => d.date !== date.format('YYYY-MM-DD'));
          this.triggerChange(this.selectedDates);
          return;
        }
        this.selectedDates.push({date: date.format('YYYY-MM-DD'), count: 1});
        this.triggerChange(this.selectedDates);
      },
      isSelected(date) {
        return this.getValue(date.format('YYYY-MM-DD')) > 0;
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/pages/tunnel/step3/card-extra-picker.vue